import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "triangle-exclamation_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M23.193 20.521a1 1 0 0 1-.878 1.48H1.685a1 1 0 0 1-.878-1.48L11.122 1.61a1 1 0 0 1 1.756 0L23.193 20.52ZM12.367 8a1 1 0 0 1 .992 1.124l-.516 4.132a.85.85 0 0 1-1.686 0l-.517-4.132A1 1 0 0 1 11.633 8h.734ZM10.5 17.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }